// Divider ("ตีเส้น") — a sentinel order line the mobile order apps insert to draw a
// separator between groups of items on an order. It is NOT a flag: every producer
// (both mobile apps' OrderItemAdapter.addLine + legacy web vm.cart.drawLine) stamps
// the same magic values, and the canonical marker is `subItemId === 1`.
//
//   { subItemId: 1, name: "===========", price: 0, quantity: 1 }
//
// The `isDivider` boolean also travels on the wire but is ALWAYS false in practice
// (setDivider(true) is never called anywhere) — do not rely on it; keep it only as an
// OR fallback in case a future producer starts setting it.
//
// Legacy behaviour we mirror:
//  - Table/terminal reconstruction SKIPS dividers (they never persist on the table).
//  - Kitchen print (V2) prints the divider as its own row, forced onto every station
//    the order touches.

export const DIVIDER_SUBITEM_ID = 1
export const DIVIDER_NAME = '==========='

export function isDividerItem(item: any): boolean {
  if (!item) return false
  return Number(item.subItemId ?? item.subitemid) === DIVIDER_SUBITEM_ID || item.isDivider === true
}
